import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { ConsentTemplate } from '@/consent/types/consent-template-api';

/**
 * Consent template library — CG-F4 / PROD-1067.
 *
 *   GET /api/ConsentTemplate/List → ConsentTemplate[]
 *
 * Contract: Scrips.Patient `ConsentTemplateController.List` (PR #882).
 * Global library (no PHI). Save / publish / retire mutations invalidate this.
 */
export function useConsentTemplates() {
  return useQuery({
    queryKey: ['consent-templates'],
    queryFn: ({ signal }) =>
      get<ConsentTemplate[]>('/api/ConsentTemplate/List', { signal }),
    staleTime: 60_000,
  });
}
